import dayjs from 'dayjs';
import Autoload from '../../Autoload';
import moment from 'moment';

const { checkProperty } = Autoload.MainHelper;

class TenantDataHandler {
  static setTenantFormData = (tenant, current) => {
    const formData = {
      id: checkProperty(tenant, 'id'),
      name: checkProperty(tenant, 'fullName'),
      email: checkProperty(tenant, 'email'),
      phone: checkProperty(tenant, 'phone'),
      in: checkProperty(tenant, 'moveInDate') 
      ? moment(checkProperty(tenant, 'moveInDate')).format('DD.MM.YYYY') 
      : '',
      out: checkProperty(tenant, 'moveOutDate')
      ? moment(checkProperty(tenant, 'moveOutDate')).format('DD.MM.YYYY')
      : '',
      type: checkProperty(tenant, 'contractType'),
      note: checkProperty(tenant, 'notes'),
      current: current,
      createdOn: checkProperty(tenant, 'createdOn'),
      vacant: checkProperty(tenant, 'vacant'),
      rentalUnitId: checkProperty(tenant, 'rentalUnitId'),
      updatedOn: checkProperty(tenant, 'updatedOn'),
      numberOfOccupants: tenant.numberOfOccupants,
      isSecondaryAddressActive: tenant.isSecondaryAddressActive || false,
      secondaryAddressName: tenant.secondaryAddressName || null,
      secondaryAddressStreet: tenant.secondaryAddressStreet || null,
      secondaryAddressZipCode: tenant.secondaryAddressZipCode || null,
      secondaryAddressCity: tenant.secondaryAddressCity || null
    }
    return formData;
  };
}

export default TenantDataHandler;
